import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { DownloadIcon } from 'assets/icons';
import { LinkText } from 'common/components';
import { useFileUrl } from 'common/components/Document';
import { Flex } from 'components/styled/Flex';

import { IDocumentProps } from './Document';
import { AnchorButtonContainer, Image, ImageContainer } from './ImageDocument.styled';

interface ImageDocumentInterface extends IDocumentProps {
  disableAsImageBtn?: boolean;
  disableAsPdfBtn?: boolean;
  margin?: string;
}

const ImageDocument = ({
  src,
  title,
  disableAsImageBtn,
  disableAsPdfBtn,
  margin,
}: ImageDocumentInterface) => {
  const { t } = useTranslation();
  const { colors, fontFamily, fontSize } = useTheme();

  const { fileUrl } = useFileUrl({ pdfBlob: src });

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <>
      <AnchorButtonContainer justifyContent="flex-end" margin={margin}>
        {!disableAsImageBtn && (
          <Flex alignItems="center" margin="0 1.5rem 0 0" cursor="pointer">
            <DownloadIcon stroke={colors.primary_dark} width={20} height={20} />

            <LinkText
              fontFamily={fontFamily.medium}
              fontSize={fontSize.sm}
              fontWeight="400"
              color={colors.primary_dark}
              href={fileUrl}
              download={isIOS ? undefined : `${title}.jpg`}
              margin="0 0 0 0.5rem"
              target={isIOS ? '_blank' : '_self'}
            >
              {t('Download as picture')}
            </LinkText>
          </Flex>
        )}

        {!disableAsPdfBtn && (
          <Flex alignItems="center" cursor="pointer">
            <DownloadIcon stroke={colors.primary_dark} width={20} height={20} />

            <LinkText
              fontFamily={fontFamily.medium}
              fontSize={fontSize.sm}
              fontWeight="400"
              color={colors.primary_dark}
              href={fileUrl}
              download={`${title}.pdf`}
              margin="0 0 0 0.5rem"
            >
              {t('Download as pdf')}
            </LinkText>
          </Flex>
        )}
      </AnchorButtonContainer>

      {!disableAsImageBtn && (
        <ImageContainer flexDirection="column">
          <Image src={fileUrl} alt={title} />
        </ImageContainer>
      )}
    </>
  );
};

export const ImageDocumentMemoized = memo(ImageDocument);
